export const WALMART_COLOR = 'var(--walmart--primary-color)';
